export default "__VITE_ASSET__Dcxam2i4__"